import React from "react";
import { useSupportWidget } from "../hooks/useSupportWidget";
import ExlySupportWidget from "./ExlySupportWidget";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";

export const SupportWidgetWrapper = withComponentLibraryTheme(() => {
  const { shouldShowSupportWidget } = useSupportWidget();

  if (!shouldShowSupportWidget) {
    return null;
  }

  return (
    <ExlySupportWidget
      position="bottom-right"
      theme={{
        primaryColor: "#493AB1",
        buttonColor: "#493AB1",
        buttonHoverColor: "#493AB1",
        messageBubbleColor: "#4A3AB1",
      }}
    />
  );
});
